import { IconShoppingCart } from "@tine/designsystem-icons/sharp";
import { Button } from "@tine/designsystem-ui-react";
import { observer } from "mobx-react-lite";

import { translateOrderType } from "../../common/utils";
import SlideFromSide from "../../components/common/slidefromside/SlideFromSide";

import authStore from "../../stores/auth/authStore";
import cartStore from "../../stores/cart/cartStore";

import theme from "../../themes/theme";
import MiniCartContent from "./MiniCartContent";
import MiniCartDates from "./MiniCartDates";
import MiniCartGoToCart from "./MiniCartGoToCart";

const MiniCart = () => {
   const itemCount = cartStore.items.reduce((s, i) => s + i.qty, 0);
   const isLoggedIn = authStore.isLoggedIn();

   return (
      <>
         <Button
            data-testid="minicart-button"
            variant={isLoggedIn && itemCount === 0 ? "secondary" : "primary"}
            size="full"
            id="mini-cart"
            onClick={cartStore.showMiniCart}
            disabled={!isLoggedIn}
            icon={<IconShoppingCart />}
         >
            <div className="ml-1 font-bold">{isLoggedIn ? itemCount : 0}</div>
         </Button>

         <SlideFromSide
            show={cartStore.miniCartVisible}
            side="right"
            onHide={cartStore.hideMiniCart}
            renderHeader={() => (
               <>
                  <h2 className="m-0 px-1 py-0 @[575px]:px-2">
                     {translateOrderType(cartStore.orderType, theme.storeCompanyName)}
                  </h2>
               </>
            )}
            renderFooter={() => <MiniCartGoToCart />}
         >
            <div className="flex min-h-full w-[min(90vw,576px)] flex-col @container">
               {authStore.isLoggedIn() && <MiniCartDates />}
               <MiniCartContent />
            </div>
         </SlideFromSide>
      </>
   );
};

export default observer(MiniCart);
